import { getDashboardLanguage } from "i18n/dashboardLanguage";

export const getTextWithEllipses = (text: string, cap: number): string => {
  let updatedText = text;

  if (updatedText.length > cap) {
    updatedText = updatedText.slice(0, cap) + " ...";
  }

  return updatedText;
};

export const Capitalize = (text?: any): string => {
  if (typeof text === "string") {
    return text.charAt(0).toUpperCase() + text.slice(1);
  } else {
    return "";
  }
};

export function formatStatNumber(num?: any): string {
  if (typeof num !== "number") {
    return "0";
  }

  if (Math.abs(num) < 999) {
    return num.toString();
  } else if (Math.abs(num) < 999999) {
    return (Math.sign(num) * (Math.abs(num) / 1000)).toFixed(1) + "k";
  } else {
    return (Math.sign(num) * (Math.abs(num) / 1000000)).toFixed(1) + "M";
  }
}

export function containsNonDigits(input: string) {
  const regex = /[^0-9]/;
  return regex.test(input);
}

export const isPhoneInput = (input: string): boolean => {
  const regex = /^[\d\s()+./-]*$/;
  return regex.test(input);
};

export const arePhoneNumbersTheSame = (
  phone1: string,
  phone2: string
): boolean => {
  const normalizePhone = (phone: string): string => {
    const digitsOnly = phone.replace(/\D/g, "");

    if (digitsOnly.length === 12 && digitsOnly.startsWith("251")) {
      return `0${digitsOnly.slice(3)}`;
    }

    if (digitsOnly.length === 9) {
      return "0" + digitsOnly;
    }

    return digitsOnly;
  };

  const normalizedPhone1 = normalizePhone(phone1);
  const normalizedPhone2 = normalizePhone(phone2);

  return normalizedPhone1 === normalizedPhone2;
};

export const hasMinimumPhoneDigits = (
  phone: string,
  minimumDigits = 6
): boolean => phone.replace(/\D/g, "").length >= minimumDigits;

export const getPrice = (text?: any): string => {
  if (typeof text === "number") {
    const formattedPrice = text.toLocaleString("en-US");
    return `${formattedPrice} Birr`;
  } else if (typeof text === "string" && !isNaN(Number(text))) {
    const numericValue = Number(text);
    const formattedPrice = numericValue.toLocaleString("en-US");
    return `${formattedPrice} Birr`;
  } else {
    return "";
  }
};

export const formatDate = (dateString?: string): string => {
  if (!dateString) return "";
  const months: string[] = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const days: string[] = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const date: Date = new Date(dateString);

  const day: string = days[date.getDay()];
  const month: string = months[date.getMonth()];
  const dayOfMonth: number = date.getDate();
  const hours: number = date.getHours();
  const minutes: number = date.getMinutes();
  const ampm: string = hours >= 12 ? "PM" : "AM";
  const formattedHours: number = hours % 12 || 12;

  return `${day} ${dayOfMonth} ${month} ${formattedHours}:${
    minutes < 10 ? "0" + minutes : minutes
  } ${ampm}`;
};

export const getTime = (dateTimeString?: string): string => {
  if (!dateTimeString) return "";
  const date: Date = new Date(dateTimeString);
  if (getDashboardLanguage() === "am") {
    return date.toLocaleTimeString("am-ET", {
      hour: "numeric",
      minute: "2-digit",
    });
  }
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${formattedHours}:${formattedMinutes} ${ampm}`;
};

export function getMonthDate(date: string): string {
  if (!date) {
    return "";
  }

  const currentDate = new Date();
  const inputDate = new Date(date);

  const today = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  const yesterday = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate() - 1
  );

  if (inputDate.toDateString() === today.toDateString()) {
    return getDashboardLanguage() === "am" ? "ዛሬ" : "Today";
  } else if (inputDate.toDateString() === yesterday.toDateString()) {
    return getDashboardLanguage() === "am" ? "ትናንት" : "Yesterday";
  } else {
    const locale = getDashboardLanguage() === "am" ? "am-ET" : "en-US";
    const month = inputDate.toLocaleString(locale, { month: "short" });
    const day = inputDate.getDate();
    return `${month} ${day}`;
  }
}
